import { render, staticRenderFns } from "./SkeletonInstructor.vue?vue&type=template&id=78027a3e&scoped=true"
import script from "./SkeletonInstructor.vue?vue&type=script&lang=js"
export * from "./SkeletonInstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78027a3e",
  null
  
)

export default component.exports